import { DatePeriodTrackingName } from './../analytics.constants';
import { AngularServices } from './../../../modules/extensions-framework/angular-integration/integration-types';
import { getAngularService } from './../../../modules/core/helpers/get-angular-service';
import { RootScopeEvents } from 'common/services/root-scope-types';
import { CSVHelper } from './../../../modules/core/helpers/csv-helper';
import { selectInstitution } from './../../../store/features/system';
import { API } from '../../../vendor/api';
import { AnalyticsHelpers } from '../analytics.helpers';
import { isLocationsAvailable } from '../../../modules/core';
export const getMeetingHistoryForCSVByParams = ({ start, end, intl }) => async (dispatch, getState) => {
    const rootScope = getAngularService(AngularServices.RootScope);
    const state = getState();
    const institution = selectInstitution(state);
    const startTime = Date.now();
    const { analytics: { datePeriod, filter: { providersIds, roomsIds, locationIds }, }, } = state;
    const isLocationsEnabled = isLocationsAvailable();
    let dataForCSV = [];
    const institutionId = institution ? institution.id : null;
    const NO_DATA = intl.formatMessage({ id: 'csvHeaders.noData' });
    const NONE = intl.formatMessage({ id: 'csvHeaders.none' });
    const headerForCSV = {
        createdHeader: intl.formatMessage({ id: `csvHeaders.created` }),
        providerNameHeader: intl.formatMessage({
            id: `csvHeaders.providerName`,
        }),
        emailHeader: intl.formatMessage({ id: `csvHeaders.email` }),
        slugHeader: intl.formatMessage({ id: `csvHeaders.slug` }),
        locationHeader: undefined,
        startTimeHeader: intl.formatMessage({ id: `csvHeaders.startTime` }),
        endTimeHeader: intl.formatMessage({ id: `csvHeaders.endTime` }),
        durationHeader: intl.formatMessage({ id: `csvHeaders.duration` }),
        waitTimeHeader: intl.formatMessage({ id: `csvHeaders.waitTime` }),
        providerRating: intl.formatMessage({ id: `csvHeaders.providerRating` }),
        providerIssues: intl.formatMessage({ id: `csvHeaders.providerIssues` }),
        providerComment: intl.formatMessage({ id: `csvHeaders.providerComment` }),
        patientRatings: intl.formatMessage({ id: `csvHeaders.patientRatings` }),
        patientIssues: intl.formatMessage({ id: `csvHeaders.patientIssues` }),
        patientComments: intl.formatMessage({ id: `csvHeaders.patientComments` }),
    };
    if (isLocationsEnabled) {
        headerForCSV.locationHeader = intl.formatMessage({
            id: `csvHeaders.location`,
        });
    }
    if (institutionId) {
        headerForCSV.providerRating = intl.formatMessage({
            id: `csvHeaders.providerCallRating`,
        });
        headerForCSV.providerIssues = intl.formatMessage({
            id: `csvHeaders.providerReportedProblem`,
        });
        headerForCSV.providerComment = intl.formatMessage({
            id: `csvHeaders.providerComment`,
        });
    }
    const addLeadingZero = (val) => (val < 10 ? `0${val}` : val);
    const formatDate = (item) => {
        if (!item) {
            return NO_DATA;
        }
        const date = new Date(item);
        const MM = addLeadingZero(date.getMonth() + 1);
        const DD = addLeadingZero(date.getDate());
        const YYYY = date.getFullYear();
        return `${MM}/${DD}/${YYYY}`;
    };
    const formatTime = (item) => {
        if (!item) {
            return NO_DATA;
        }
        return AnalyticsHelpers.rawDataToStartTime(item);
    };
    const getFileName = () => {
        const date = new Date();
        const MM = addLeadingZero(date.getMonth() + 1);
        const DD = addLeadingZero(date.getDate());
        const YYYY = date.getFullYear();
        let timeZone;
        try {
            timeZone = Intl.DateTimeFormat()
                .resolvedOptions()
                .timeZone.replace('/', '_');
        }
        catch (e) { }
        return timeZone
            ? `meeting_history_${MM}_${DD}_${YYYY}_${timeZone}`
            : `meeting_history_${MM}_${DD}_${YYYY}`;
    };
    const trackExportMeetingHistory = async (error) => {
        let isPersonal = false;
        const track = {
            date_filter: DatePeriodTrackingName[datePeriod],
            generating_time: Date.now() - startTime,
            lines_number: !error ? dataForCSV.length : null,
        };
        switch (true) {
            case providersIds.length > 0:
                Object.assign(track, {
                    provider_filter: 'provider',
                    export_id: providersIds[0],
                });
                break;
            case roomsIds.length > 0:
                const room = await API.room.findRoomById({ id: roomsIds[0] });
                isPersonal = room.isPersonal;
                Object.assign(track, {
                    provider_filter: isPersonal ? 'personal' : 'shared',
                    export_id: roomsIds[0],
                });
                break;
            case locationIds.length > 0:
                Object.assign(track, {
                    provider_filter: 'location',
                    export_id: locationIds[0],
                });
                break;
            default:
                Object.assign(track, {
                    provider_filter: 'all',
                    export_id: null,
                });
        }
        rootScope.$emit(RootScopeEvents.ANALYTICS.MEETING_HISTORY_EXPORT, {
            button_action: 'meeting history exported',
            button_text: 'export meeting history',
            context: 'page',
            error: (error && `${error.name} ${error.message} ${error.stack}`) || null,
            details: [track],
        });
    };
    try {
        dataForCSV = (await API.meetingHistory.getMeetingHistoryForCSVByParams({
            institutionId,
            userIds: providersIds,
            roomIds: roomsIds,
            locationIds: locationIds,
            start,
            end,
        }));
        const firstRowContent = dataForCSV[0];
        const fileBody = [];
        if (firstRowContent) {
            const headerFields = [
                firstRowContent.hasOwnProperty('startTime')
                    ? headerForCSV.createdHeader
                    : null,
                firstRowContent.hasOwnProperty('providerName')
                    ? headerForCSV.providerNameHeader
                    : null,
                firstRowContent.hasOwnProperty('email')
                    ? headerForCSV.emailHeader
                    : null,
                firstRowContent.hasOwnProperty('slug')
                    ? headerForCSV.slugHeader
                    : null,
                isLocationsEnabled && firstRowContent.hasOwnProperty('location')
                    ? headerForCSV.locationHeader
                    : null,
                firstRowContent.hasOwnProperty('startTime')
                    ? headerForCSV.startTimeHeader
                    : null,
                firstRowContent.hasOwnProperty('endTime')
                    ? headerForCSV.endTimeHeader
                    : null,
                firstRowContent.hasOwnProperty('duration')
                    ? headerForCSV.durationHeader
                    : null,
                firstRowContent.hasOwnProperty('waitTime')
                    ? headerForCSV.waitTimeHeader
                    : null,
                firstRowContent.hasOwnProperty('providerRating')
                    ? headerForCSV.providerRating
                    : null,
                firstRowContent.hasOwnProperty('providerIssues')
                    ? headerForCSV.providerIssues
                    : null,
                firstRowContent.hasOwnProperty('providerComment')
                    ? headerForCSV.providerComment
                    : null,
                firstRowContent.hasOwnProperty('patientRatings')
                    ? headerForCSV.patientRatings
                    : null,
                firstRowContent.hasOwnProperty('patientIssues')
                    ? headerForCSV.patientIssues
                    : null,
                firstRowContent.hasOwnProperty('patientComments')
                    ? headerForCSV.patientComments
                    : null,
            ]
                .filter((item) => !!item)
                .map((item) => `"${CSVHelper.escapeString(item)}"`)
                .join(',');
            fileBody.push(headerFields);
        }
        dataForCSV.forEach((rowContent) => {
            const rowFields = [
                rowContent.hasOwnProperty('startTime')
                    ? formatDate(rowContent.startTime)
                    : null,
                rowContent.hasOwnProperty('providerName')
                    ? rowContent.providerName
                    : null,
                rowContent.hasOwnProperty('email')
                    ? rowContent.email || NO_DATA
                    : null,
                rowContent.hasOwnProperty('slug') ? rowContent.slug || NO_DATA : null,
                isLocationsEnabled && rowContent.hasOwnProperty('location')
                    ? // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                        rowContent.location?.name || NO_DATA
                    : null,
                rowContent.hasOwnProperty('startTime')
                    ? formatTime(rowContent.startTime)
                    : null,
                rowContent.hasOwnProperty('endTime')
                    ? formatTime(rowContent.endTime)
                    : null,
                rowContent.hasOwnProperty('duration')
                    ? rowContent.duration || NO_DATA
                    : null,
                rowContent.hasOwnProperty('waitTime')
                    ? rowContent.waitTime || NO_DATA
                    : null,
                rowContent.hasOwnProperty('providerRating')
                    ? rowContent.providerRating || ' '
                    : null,
                rowContent.hasOwnProperty('providerIssues')
                    ? rowContent.providerIssues || ' '
                    : null,
                rowContent.hasOwnProperty('providerComment')
                    ? rowContent.providerComment ||
                        (rowContent.providerRating ? NONE : ' ')
                    : null,
                rowContent.hasOwnProperty('patientRatings')
                    ? rowContent.patientRatings.length
                        ? rowContent.patientRatings.join(',')
                        : ' '
                    : null,
                rowContent.hasOwnProperty('patientIssues')
                    ? rowContent.patientIssues.length
                        ? rowContent.patientIssues.join('||')
                        : ' '
                    : null,
                rowContent.hasOwnProperty('patientComments')
                    ? rowContent.patientComments.length
                        ? rowContent.patientComments
                            .map((comment) => comment ? `${comment}`.replace(/[|]+/g, '|') : `${NONE}`)
                            .join('||')
                        : ' '
                    : null,
            ]
                .filter((item) => !!item)
                .map((item) => `"${CSVHelper.escapeString(item)}"`)
                .join(',');
            fileBody.push(rowFields);
        });
        const fileName = getFileName();
        CSVHelper.saveCSV(fileName, fileBody);
        trackExportMeetingHistory();
    }
    catch (e) {
        trackExportMeetingHistory(e);
        console.error('Error in action "getMeetingHistoryForCSV": ', e);
    }
};
